import { shopCall } from '../shop-shared/transport';
import type { OrderConfirmation, ShopMerciInitData } from './types';

export function getOrderConfirmation(init: ShopMerciInitData): Promise<OrderConfirmation> {
    const data: Record<string, unknown> = {};
    if (init.order_id) data.order_id = init.order_id;
    if (init.session_id) data.session_id = init.session_id;
    return shopCall<OrderConfirmation>(init, 'gas_get_order_confirmation', data);
}
